module.exports = __webpack_public_path__ + "img/qrcode.0ee10ddb.png";